module.exports = __webpack_public_path__ + "main/images/learnmore/download-in-play-store.cf9e19ea23c0d577c5e28f7a12aac0c1.svg";